module.exports = __webpack_public_path__ + "static/media/Galano_Grotesque_Semi_Bold.e3ab1514.otf";